import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { AbilitiesSVG } from '../svg/abilities.svg';

const AbilitiesIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <AbilitiesSVG/>
    </div>
  );
};

export { AbilitiesIcon };
